"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnextInterface = void 0;
const ethers_1 = require("ethers");
const abi_1 = require("./abi");
const connextAbi = abi_1.ConnextAbi.concat(abi_1.TokenFacetAbi.filter((k) => k.includes("event"))
    .concat(abi_1.BridgeFacetAbi.filter((k) => k.includes("event")))
    .concat(abi_1.InboxFacetAbi.filter((k) => k.includes("event"))));
exports.ConnextInterface = new ethers_1.utils.Interface(connextAbi);
//# sourceMappingURL=contracts.js.map